import { render } from "./MultiSelect.vue?vue&type=template&id=7cb35ee6"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script